import {BackendService} from "../services/backend/backend-service";
import { defineNuxtPlugin } from "nuxt/app";
import { useProductStore } from "../stores/products";
import { useCustomerStore } from "../stores/customers";
import { useOrganisationStore } from "../stores/organisations";
import { useVoucherStore } from "../stores/vouchers";
import { useOrderStore } from "../stores/orders";
import { useInvoiceStore } from "../stores/invoices";
import { useTnCStore } from "../stores/termsAndConditions";
import { useAuthStore } from "../stores/auth";
import { NuxtApp } from "#app/nuxt";


export class LoggingService {

  constructor(private enabled: boolean) {
  }

  info(message: string, ...data: any) {
    if (this.enabled) {
      console.log(message, data);
    }
  }

  debug(message: string, ...data: any) {
    if (this.enabled) {
      console.debug(message, data);
    }
  }

  error(message: string, ...data: any) {
    // Fehler IMMER ausgeben, sonst sind Frontend-Probleme unsichtbar
    // (catch(e) loggt nichts, User sieht nur die generische Toast-Meldung).
    console.error(message, ...data);
  }
}
export default defineNuxtPlugin((nuxtApp) => {
  return {
    provide: {
      logger: new LoggingService(false),
      backendService: new BackendService(nuxtApp as NuxtApp),
      authStore: useAuthStore(),
      customerStore: useCustomerStore(),
      organisationStore: useOrganisationStore(),
      voucherStore: useVoucherStore(),
      productStore: useProductStore(),
      orderStore: useOrderStore(),
      invoiceStore: useInvoiceStore(),
      termsConditionsStore: useTnCStore(),
      tenant: useTenantStore(),
    }
  };
});